import React, { PureComponent } from 'react'

class Home extends PureComponent {
  render() {
    return <h1 className="page-title">Britive - CPAM</h1>
  }
}

export default Home
